export default {
  props: {
    formName: {
      type: String,
      required: true
    },
    gtmFormName: {
      type: String,
      required: false
    }
  },
  methods: {
    sendGtmEvent(formField) {
      this.gtmPush({
        event: 'form_progress',
        'form.name': this.gtmFormName || this.formName,
        'form.field': formField
      });
    },
    handleFocusWithFormGtm(formField, event) {
      this.sendGtmEvent(formField);
      if (!event?.target || typeof event.target.scrollIntoView !== 'function') {
        return;
      }
      const target = event.target;
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 300);
    }
  }
};
